import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { InviteHouseholdMemberRequest } from '@/models/Household';
import {
  getHousehold,
  inviteHouseholdMember,
  removeHouseholdMember,
} from '@/services/api/household';

export const HOUSEHOLD_QUERY_KEY = ['household'];

/** The caller's HomeHQ household: who the home is shared with and how many seats are left. */
export const useHousehold = (enabled = true) =>
  useQuery({
    queryKey: HOUSEHOLD_QUERY_KEY,
    queryFn: getHousehold,
    enabled,
    staleTime: 30 * 1000,
  });

export const useInviteHouseholdMember = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: InviteHouseholdMemberRequest) => inviteHouseholdMember(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: HOUSEHOLD_QUERY_KEY });
    },
  });
};

export const useRemoveHouseholdMember = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (memberId: string) => removeHouseholdMember(memberId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: HOUSEHOLD_QUERY_KEY });
      // A member who leaves loses the shared home.
      queryClient.invalidateQueries({ queryKey: ['properties'] });
    },
  });
};
